<script setup>
import { ref, computed, defineAsyncComponent, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
/***/
import { useApplicationStore } from '@stores/application';
/***/
import { useAuthUser } from '@compositions/Auth';
import { useTaskConfiguration } from '@compositions/Task/Configuration/TaskConfiguration';

// Composants
const Loader = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/UI/Loader'));
const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Authenticated'));
const Wrapper = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Admin/HorseChestnut/Wrapper'));

const router = useRouter();
const { t } = useI18n();

// Stores
const applicationStore = useApplicationStore();

// Application et utilisateur connecté
const currentApplication = computed(() => applicationStore.getCurrent);
const { authUserHasPermission } = useAuthUser({});

// Composition pour le chargement des configurations de tâche
const {
    loadingTaskConfigurations,
    loadingTaskConfigurationsError,
    loadTaskConfiguration
} = useTaskConfiguration({});

const allowed = ref(false);

onMounted(() => {

    const canConsult = (authUserHasPermission('consult horse chestnut events'));

    if(! canConsult) {
        router.push({
            name: 'error',
            params: {
                statusCode: 404
            }
        });
    } else {
        const titleKey = 'page.admin.horseChestnut.list.title';
        document.title = t(titleKey) + ' - ' + currentApplication.value.name;
        allowed.value = true;

        loadTaskConfiguration().then(() => {

        })
    }
});
</script>

<template>
    <layout v-if="allowed">

        <loader v-if="loadingTaskConfigurations"></loader>
        <p
            v-else-if="loadingTaskConfigurationsError"
            class="generic-message generic-message-error"
        >
            {{ $t('page.admin.horseChestnut.list.loadResources.error') }}
        </p>
        <template v-else>
            <div class="horse-chestnut-wrapper">
                <wrapper></wrapper>
            </div>
        </template>
    </layout>
</template>
